import React from 'react'
import {connect} from 'react-redux'

import {Modal} from '../../data/data'

import ResidueRuleEditor from "../Wherehouse/WarehouseParts/PartEditor/ResidueRuleEditor";
import RegistrationPartEditor from "../Wherehouse/WarehouseRegistration/RegistrationPartEditor";
import WriteOfEditor from "../Wherehouse/WarehouseWriteOf/WriteOfEditor";
import PaymentCard from '../Payments/PaymentCard'
import WarehouseMovementEditor from "../Wherehouse/WarehouseMovement/WarehouseMovementEditor";
import InventoryEditorPreview from "../Wherehouse/WarehouseInventories/InventoryEditorPreview";
import WarehouseBackEditor from "../Wherehouse/WarehouseBacks/WarehouseBackEditor";
import CashRegisterEmployeeEditor from "../Payments/cash_registers/CashRegisterEmployeeEditor";
import WarehouseCategoryEditor from "../Wherehouse/WarehouseParts/WarehouseCategoryEditor";
import SalaryRuleReducer from "../Settings/SettingPages/Employees/SalaryRuleEditor";
import WarehouseEmployeeEditor from "../Settings/SettingPages/Wherehouse/WarehouseEmployeeEditor";


const CentralModal = (props) => {

    const getModal = () => {
        switch (props.view.modalCentralType) {

            case Modal.Type.RESIDUE_RULE:
                return <ResidueRuleEditor/>

            case Modal.Type.REGISTRATION_PART:
                return <RegistrationPartEditor/>

            case Modal.Type.WRITE_OFF:
                return <WriteOfEditor/>

            case Modal.Type.PAYMENT_CARD:
                return <PaymentCard/>

            case Modal.Type.WAREHOUSE_MOVEMENT:
                return <WarehouseMovementEditor/>

            case Modal.Type.INVENTORY_PREVIEW:
                return <InventoryEditorPreview/>

            case Modal.Type.BACK:
                return <WarehouseBackEditor/>

            case Modal.Type.CASH_REGISTER_EMPLOYEE:
                return <CashRegisterEmployeeEditor/>

            case Modal.Type.WAREHOUSE_CATEGORIES:
                return <WarehouseCategoryEditor/>

            case Modal.Type.SALARY_RULE:
                return <SalaryRuleReducer/>

            case Modal.Type.WAREHOUSE_EMPLOYEE:
                return <WarehouseEmployeeEditor/>
        }
    }

    if (!props.view.isCentralModalOpen) return null

    return (
        <div className="modal z9999">
            <div className='modal__box'>
                <div>{getModal()}</div>
            </div>

        </div>
    )

}

const mapStateToProps = state => ({
    view: state.view
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CentralModal)